/* eslint-disable import/first */
import './lib/customEventPolyfill';
import './lib/clearAllIntervals';
import 'intl';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import jack from 'jack-logs';
import emitter from 'react-ab-test/lib/emitter';
import Router from './router';
import airbrake from './lib/Airbrake'; // log errors earlier in the app lifecycle
import { capFirst } from './lib/strings';
import store from './store';
import IntlProvider from './components/IntlProvider';
import attachEventListeners from './lib/attachEventListeners';
import { googleInit } from './lib/google';
import './lib/perfRecorder';
import './lib/Intercom';
import './lib/segment';
import './components/animations.scss';
import './components/fonts.scss';
import './components/loadfonts';
import './lib/GetUserMedia';
import statsd from './lib/StatsD';
import TouchFix from './lib/compat/ios';
/* eslint-enable import/first */

attachEventListeners(store);

/**
 * on ios register body with TouchFix
 */
if (window.platform === 'ios') {
  TouchFix.attach(document.body);
}

(async () => {
  if (!window.device || !window.cordova || !window.cordova.getAppVersion) {
    return null;
  }
  try {
    const details = {
      type: capFirst(window.device.manufacturer),
      model: window.device.model,
      os: window.device.platform,
      osVersion: window.device.version,
      app: await window.cordova.getAppVersion.getVersionNumber(),
    };

    fetch(`${process.env.TIMECLOCK_SERVER}/device`, {
      body: JSON.stringify(details),
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    }).catch(e => jack.error(e));
  } catch (e) {
    airbrake.notify(e);
  }
  return null;
})();

const constraints = { // video constraints {legacy android}
  audio: false,
  video: {
    mandatory: {
      minHeight: 480, minWidth: 480, maxHeight: 480, maxWidth: 480,
    },
    optional: [],
  },
};

if (navigator.mediaDevices.getSupportedConstraints().facingMode) {
  constraints.video.optional.push({ facingMode: 'user' });
}

navigator.mediaDevices.getUserMedia(constraints)
  .then((stream) => {
    try {
      window.videostream = window.URL.createObjectURL(stream);
      window.deprecatedVideoStream = true;
    } catch (error) {
      window.videostream = stream;
      window.deprecatedVideoStream = false;
    }
  })
  .catch((error) => { jack.error({ message: 'getUserMedia failed', error }); });

googleInit();

if (!window.facebookConnectPlugin) {
  // load in a debug version
  window.facebookConnectPlugin = {
    logEvent(string) {
      console.log(`Facebook Connect Log Event => ${string}`);
    },
  };
}

window.__STORE__ = store; // eslint-disable-line

if (window.NATIVE_INTERCOM) {
  window.intercom.logEvent('app_opened');
} else {
  window.Intercom('trackEvent', 'app_opened'); // eslint-disable-line
}

emitter.addPlayListener((experimentName, variantName) => {
  statsd.increment(`abtest.${experimentName}.display.${variantName}`);
  if (window.analytics && window.analytics.track) {
    window.analytics.track(`tc-${experimentName}-${variantName}-viewed`);
  }
});

emitter.addWinListener((experimentName, variantName) => {
  statsd.increment(`abtest.${experimentName}.win.${variantName}`);
  if (window.analytics && window.analytics.track) {
    window.analytics.track(`tc-${experimentName}-${variantName}-clicked`);
  }
});

/**
 * @param  {Component} the root component of the application
 */
ReactDOM.render(
  <Provider store={store}>
    <IntlProvider>
      <Router />
    </IntlProvider>
  </Provider>,
  document.getElementById('app'),
);



// WEBPACK FOOTER //
// ./src/main.jsx